import "../../App.scss";
import React, { useEffect } from "react";
import Navbar from "./Navbar/Navbar";
import Banner from "./Banner/Banner";


function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
<Navbar/>
<Banner/>
    </>
  );
}

export default Landing;
